// src/api.js
import axios from 'axios';

function getBaseURL() {
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  if (typeof process !== 'undefined' && process.env?.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
    return 'https://iso.ringenioussolutions.com/api';
//   return 'http://localhost:5003/api';
}

const API = axios.create({
  baseURL: getBaseURL(),
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true, // was false — enable cookies for auth
});

// Optional: keep your interceptor
API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (!err.response) {
      err.response = { status: 0, data: { error: 'Network or CORS error' } };
    }
    return Promise.reject(err);
  }
);

export default API;
